import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M13.7 18.5c-1.15.5-2.4.75-3.7.75C4.9 19.25.75 15.1.75 10c0-2.25.8-4.3 2.1-5.9M6.15 1.6C7.3 1.05 8.65.75 10 .75c5.1 0 9.25 4.15 9.25 9.25 0 2-.65 3.85-1.7 5.35"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M10 9.25v5.5"
    }, null, -1)
  ]))]))
}
export default { render: render }